var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('FormContainer',{on:{"submitForm":function($event){return _vm.$emit('submitForm', $event)}},scopedSlots:_vm._u([{key:"default",fn:function(){return [_vm._t("default")]},proxy:true}],null,true)})}
var staticRenderFns = []

export { render, staticRenderFns }